import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IStylingFirm } from './Entities';
import * as Actions from './actions/StylingFirmsActions';
import StylingFirmsList from './list/StylingFirmsList';
import { Translate } from '../../shared/LanguageService';
import { Button } from 'react-bootstrap';
import StylingFirmsModal from './StylingFirmsModal';
import LogsModal from '../logs/LogsModal';
import ConfirmationModal from '../../components/common/ConfirmationModal';

class StylingFirmsPage extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            showModal: false,
            stylingFirmId: 0,
            showLogsModal: false,
            showDeleteConfirmation: false,
            deleteId: 0
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.editFirm = this.editFirm.bind(this);
        this.viewlogs = this.viewlogs.bind(this);
        this.deleteStylingFirm = this.deleteStylingFirm.bind(this);
        this.confirmedDeleteStylingFirm = this.confirmedDeleteStylingFirm.bind(this);
    }

    componentDidMount() {
        this.props.actions.getStylingFirms();
    }

    toggleModal() {
        if (!this.state.showModal === false) {
            this.setState({ stylingFirmId: 0 });
        }
        this.setState({ showModal: !this.state.showModal });
    }

    editFirm(id: number) {
        this.setState({ stylingFirmId: id, showModal: true });
    }

    viewlogs(id: number) {
        this.setState({ stylingFirmId: id, showLogsModal: true });
    }

    deleteStylingFirm(id: number) {
        this.setState({
            showDeleteConfirmation: true,
            deleteId: id
        });
    }

    confirmedDeleteStylingFirm(id: number) {
        const stylingFirm = this.props.stylingFirms.find((stylingFirm: IStylingFirm) => {
            return stylingFirm.id === id;
        });
        this.props.actions.deleteStylingFirm(stylingFirm);
    }

    renderLogModal() {
        if (this.state.showLogsModal) {
            return (
                <LogsModal
                    id={this.state.stylingFirmId}
                    type="StylistFirmId"
                    shouldShowModal={this.state.showLogsModal}
                    closeModal={() =>
                        this.setState({
                            showLogsModal: false,
                            stylingFirmId: 0
                        })
                    }
                />
            );
        }
    }

    renderConfirmModal() {
        if (this.state.showDeleteConfirmation) {
            return (
                <ConfirmationModal
                    title={Translate('styling-firm/modal/remove/confirmation/title')}
                    text={Translate('styling-firm/modal/remove/confirmation/description')}
                    doButtonLabel={Translate('styling-firms/list/row/button-label/delete')}
                    cancelButtonLabel={Translate('styling-firms/list/row/button-label/abort')}
                    doButtonStyle="danger"
                    do={() => {
                        this.confirmedDeleteStylingFirm(this.state.deleteId);
                        this.setState({
                            showDeleteConfirmation: false,
                            deleteId: 0
                        });
                    }}
                    closeModal={() => {
                        this.setState({
                            showDeleteConfirmation: false,
                            deleteId: 0
                        });
                    }}
                />
            );
        }
    }

    render() {
        return (
            <div>
                {this.renderLogModal()}
                {this.renderConfirmModal()}
                <h1>{Translate('styling-firms/page/title/styling-firms')}</h1>

                <Button
                    bsSize="large"
                    className="pull-right"
                    onClick={this.toggleModal}
                    bsStyle="success"
                >
                    {Translate('styling-firms/page/button-label/add-styling-firm')}
                </Button>
                {this.state.showModal && (
                    <StylingFirmsModal
                        showModal={this.state.showModal}
                        toggleModal={this.toggleModal}
                        stylingFirmId={this.state.stylingFirmId}
                    />
                )}
                <StylingFirmsList
                    stylingFirms={this.props.stylingFirms}
                    editStylingFirm={this.editFirm}
                    viewlogs={this.viewlogs}
                    deleteStylingFirm={this.deleteStylingFirm}
                />
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    let stylingFirmsFromState: IStylingFirm[] = [...state.styling.list];
    let sortedList = stylingFirmsFromState.sort((a: IStylingFirm, b: IStylingFirm) => {
        return a.id - b.id;
    });
    return {
        stylingFirms: sortedList
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getStylingFirms: () => dispatch(Actions.getStylingFirms()),
            deleteStylingFirm: (stylingFirm: IStylingFirm) =>
                dispatch(Actions.deleteStylingFirm(stylingFirm))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StylingFirmsPage));
